var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('div',{attrs:{"id":"googleMap"}}),(_vm.message)?_c('Message',{attrs:{"type":_vm.message.type,"message":_vm.message.message}}):_vm._e(),_c('div',{staticClass:"contact-form"},[_c('ContactForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }